import { useState } from 'react';
import { IconChecks, IconFilter, IconMaximize, IconPlus } from '@tabler/icons-react';
import { useT } from '@hana/i18n';
import { useToast } from '@hana/ui';
import { GRP_LABEL, MY_DONE, MY_TASKS, type Grp } from './data';
import s from './myPhone.module.css';
import './i18n';

// Mint-Home-Phone (390) · khối Việc của tôi: hàng 60 — ô Xong 44 · tiêu đề + đối tượng · +4h 44. Số đo từ board (my.groups).
const dueS = (k: string) => k.replace(/^(?:Quá hạn|Quá|Trễ)\s+(.+)$/i, '−$1').replace(/^Còn\s+(?=[\d−-])/i, '');

export function MyPhone({ empty }: { empty: boolean }) {
  const t = useT();
  const toast = useToast();
  const [view, setView] = useState<'open' | 'done'>('open');
  const [done, setDone] = useState<readonly number[]>([]);
  const [all, setAll] = useState(false);
  const tip = (m: string) => toast({ msg: m });
  const open = empty ? [] : MY_TASKS;
  const shown = all ? open : open.slice(0, 8);
  const groups = (['over', 'today', 'next'] as Grp[]).map((g) => ({ g, items: shown.filter((x) => x.grp === g), n: open.filter((x) => x.grp === g).length })).filter((g) => g.items.length);
  const total = empty ? 0 : MY_TASKS.length;
  return (
    <section className={s.my} aria-label={t('home.my')}>
      <div className={s.h}>
        <b>{t('home.my')}</b>
        <button type="button" className={`${s.bt} ${s.pri}`} aria-haspopup="dialog" onClick={() => tip(t('home.later'))}><IconPlus size={16} stroke={1.8} aria-hidden="true" />{t('home.note')}</button>
        <button type="button" className={s.sq} aria-label={t('home.expandLabel')} onClick={() => tip(t('home.later'))}><IconMaximize size={16} stroke={2} aria-hidden="true" /></button>
      </div>
      <div className={s.sum}>{t('home.myCount', { n: total, o: empty ? 0 : MY_TASKS.filter((x) => x.grp === 'over').length })}</div>
      <div className={s.tools}>
        <button type="button" className={s.seg} aria-pressed={view === 'open'} onClick={() => setView('open')}>{t('home.open', { n: total })}</button>
        <button type="button" className={s.seg} aria-pressed={view === 'done'} onClick={() => setView('done')}>{t('home.done', { n: empty ? 0 : MY_DONE })}</button>
        <button type="button" className={s.seg} onClick={() => tip(t('home.later'))}><IconFilter size={16} stroke={1.8} aria-hidden="true" />{t('home.filter')}</button>
        <button type="button" className={`${s.seg} ${s.ctl}`} onClick={() => tip(t('home.later'))}><IconChecks size={16} stroke={1.8} aria-hidden="true" />{t('home.multi')}</button>
      </div>
      {view === 'done' ? <div className={s.none}>{empty ? t('home.noneDone') : t('home.doneN', { n: MY_DONE })}</div> : !groups.length ? <div className={s.none}>{t('home.noToday')}</div> : groups.map(({ g, items, n }) => (
        <div key={g}>
          <div className={`${s.gh} ${g === 'over' ? s.over : ''}`}>{GRP_LABEL[g]} · {n}</div>
          {items.map((x) => {
            const ok = done.includes(x.id);
            return (
              <div key={x.id} className={s.row}>
                <button type="button" className={s.cb} role="checkbox" aria-checked={ok} aria-label={`${t('home.doneRow')}: ${x.title}`} onClick={() => setDone((d) => (ok ? d.filter((i) => i !== x.id) : [...d, x.id]))}><span>{ok ? '✓' : ''}</span></button>
                <button type="button" className={s.body} onClick={() => tip(t('home.later'))}>
                  <div className={`${s.t} ${ok ? s.dn : ''}`}>{x.code} · {x.title}</div>
                  <div className={s.m}>{x.obj}<span className={`${s.due} ${g === 'over' ? s.over : ''}`} title={x.dueK} aria-label={x.dueK}>{dueS(x.dueK)}</span></div>
                </button>
                <button type="button" className={s.ext} aria-label={t('home.ext', { x: x.ext })} onClick={() => tip(t('home.extDone'))}><IconPlus size={16} stroke={1.8} aria-hidden="true" />4h</button>
              </div>
            );
          })}
        </div>
      ))}
      {view === 'open' && !all && open.length > shown.length && <button type="button" className={s.more} onClick={() => setAll(true)}>{t('home.seeMore', { n: open.length - shown.length })}</button>}
    </section>
  );
}
